import { useCurrentProject } from '../ProjectEntitlementsContext';

export function useProductAvailable({ productId }: { productId: string }) {
  const currentProject = useCurrentProject();
  const product = currentProject?.products.find(
    (p) => p.key === productId && p.authorized,
  );

  return Boolean(product);
}
